// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// css
import '../../styles/components/analytics/EngagementItem.scss';


class EngagementItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.item.name,
      details: props.item.details
    };

    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeDetails = this.handleChangeDetails.bind(this);
  }

  handleChangeName(event) {
    const name = event.target.value;
    this.setState({ name }, () => {
      this.props.onChange(this.state.name, this.state.details);
    });
  }

  handleChangeDetails(event) {
    const details = event.target.value;
    this.setState({ details }, () => {
      this.props.onChange(this.state.name, this.state.details);
    });
  }

  render() {
    const { onRemove } = this.props;

    return (
      <div className='analytics__engagement-customer-item analytics__engagement-item'>
        <div className='row'>
          <div className={`col-md-${this.props.columnWidths[0]}`}>
            <input
              autoFocus
              type='text'
              onChange={this.handleChangeName}
              value={this.state.name}
              className='analytics__engagement-item__name'
              placeholder={this.props.namePlaceholder}
            />
          </div>
          <div className={`col-md-${this.props.columnWidths[1]}`}>
            <input
              type='text'
              onChange={this.handleChangeDetails}
              value={this.state.details}
              className='analytics__engagement-item__details'
              placeholder={this.props.detailsPlaceholder}
            />
          </div>
          <div className={`col-md-${this.props.columnWidths[2]}`}>
            <a className='analytics__engagement-item-remove-link' onClick={onRemove}>Remove row</a>
          </div>
        </div>
      </div>
    );
  }
}

EngagementItem.propTypes = {
  item: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  columnWidths: PropTypes.array.isRequired,
  namePlaceholder: PropTypes.string,
  detailsPlaceholder: PropTypes.string
};

EngagementItem.defaultProps = {
  columnWidths: [6, 3, 3],
  namePlaceholder: 'Name',
  detailsPlaceholder: 'Details'
};

export default EngagementItem;



// WEBPACK FOOTER //
// ./src/components/analytics/EngagementItem.js